import React from 'react';
import { Grid } from '@mui/material';

interface UpdateTableFormHeaderProps {
  title: string;
  onClose: () => void;
}

export const UpdateTableFormHeader: React.FC<UpdateTableFormHeaderProps> = ({ title, onClose }) => {
  return (
    <Grid
      container
      justifyContent="space-between"
      style={{
        padding: 20,
        borderBottom: '1px solid #efefef',
        alignItems: 'center'
      }}>
      <Grid item>
        <h3 style={{ fontSize: 20, fontFamily: 'Arial' }}>{title}</h3>
      </Grid>
      <Grid item>
        <div style={{ cursor: 'pointer' }} onClick={onClose}>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#F7F7FC" />
            <path
              d="M18 18.0002L30.7742 30.7744"
              stroke="#14142B"
              strokeWidth="1.93939"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18 30.7744L30.7742 18.0002"
              stroke="#14142B"
              strokeWidth="1.93939"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </Grid>
    </Grid>
  );
};
